/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import {
  mapRemoteResource,
  useOtpDevices,
  type OtpDeviceItemHook,
} from "../api/hooks.js";
import { DevicesScreen, type DeviceItem } from "../screens/DevicesScreen.js";

export function DevicesRoute(): VNode {
  const { devices, resource, updateOtpDevice, deleteOtpDevice } =
    useOtpDevices();

  const authenticators: DeviceItem[] = devices.map((d: OtpDeviceItemHook) => ({
    id: d.id,
    name: d.name,
    algorithm: d.algorithm,
  }));
  const authenticatorsResource = mapRemoteResource(resource, (items) =>
    items.map(
      (d: OtpDeviceItemHook): DeviceItem => ({
        id: d.id,
        name: d.name,
        algorithm: d.algorithm,
      }),
    ),
  );

  return (
    <DevicesScreen
      authenticators={authenticators}
      authenticatorsResource={authenticatorsResource}
      onDeleteAuthenticator={deleteOtpDevice}
      onRotateKey={(id, name, secretKey, algorithm) =>
        updateOtpDevice(id, { name, secretKey, algorithm })
      }
    />
  );
}
